import React, { useState } from 'react';
import { ListaRascunhos } from './FaturacaoRascunhos';
import { ConfigEnsaios, ListaEnsaios } from './FaturacaoEnsaios';
export default function FaturacaoModulo(props) {
    const [tab,setTab]=useState('rascunhos');
    return <><nav className="fr-tabs fr-module-tabs" aria-label="Faturação">{[['rascunhos','Rascunhos'],['ensaios','Ensaios'],['config','Dados fiscais e séries']].map(([key,label])=><button key={key} className="fr-btn" aria-pressed={tab===key} onClick={()=>setTab(key)}>{label}</button>)}</nav>
        {tab==='rascunhos'&&<ListaRascunhos {...props}/>}{tab==='ensaios'&&<ListaEnsaios onAbrir={props.onAbrir} refresh={props.refresh}/>}{tab==='config'&&<ConfigEnsaios/>}</>;
}
